/**
 * `МЕСТА.1`, второй возврат (`АУД-Н343`): окно модуля (МДБН и СМБ) шлёт строку
 * станции целиком, вместе с `place`. Back на любой `place`, даже `null`,
 * вызывает `syncStationPlace`, и правка серийника снимала закрепление или
 * заводила лишнее место. Место уходит в запрос, только когда его правили —
 * оно названо в `__modified` этой строки.
 */
export function withoutUntouchedPlace<T extends Record<string, any>>(station: T): T {
  if (!("place" in station)) return station;

  const modified: unknown = station.__modified;

  if (Array.isArray(modified) && modified.includes("place")) return station;

  const { place, ...rest } = station;

  return rest as T;
}
